/**
 * The API still configures a single `address_address` question.
 * We split it into `home_address_line1` / `home_address_line2` on the client
 * so the form renders two inputs and submits both keys.
 */
export default function splitHomeAddressQuestion(questions) {
  if (!questions || !questions.length) return questions;
  const idx = questions.findIndex((q) => q.key === 'address_address');

  // Skip if the address_address is configured OFF, no splitting required
  if (idx === -1) return questions;

  const original = questions[idx];
  const line1 = {
    ...original,
    key: 'home_address_line1',
    title: original.title || 'Address line 1',
  };
  const line2 = {
    ...original,
    key: 'home_address_line2',
    is_required: false,
    rules: null,
    data_validation: null,
    optional: true,
    title: 'Address line 2',
  };

  return [...questions.slice(0, idx), line1, line2, ...questions.slice(idx + 1)];
}
